import React, { useEffect, useState } from "react";
import { ProgressBar, Badge } from "react-bootstrap";
import BasisTableComponent from "../table/BasisTableComponent";

const TopicsComparisonTable = ({ programId, subjectId }) => {
  const [topics, setTopics] = useState([]);
  const [yearsTopics, setYearsTopics] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pages: 1 });

  const fetchTopics = async (page = 1) => {
    try {
      const res = await fetch(`https://plo.areez.co/api/clo/subject/topics/comparison?program_id=${programId}&subject_id=${subjectId}&last_n=5&page=${page}&per_page=10`);
      const json = await res.json();

      const allYearsSet = new Set();
      json.topics.forEach((topic) =>
        Object.keys(topic.achievement_by_year).forEach((year) =>
          allYearsSet.add(year)
        )
      );

    //   setYearsTopics(Array.from(allYearsSet));
    setYearsTopics(Array.from(allYearsSet).sort((a, b) => parseInt(a) - parseInt(b)));

      setTopics(json.topics);
      setPagination({
        page: json.page,
        pages: Math.ceil(json.total_topics / json.per_page),
      });
    } catch (err) {
      console.error("فشل جلب بيانات المواضيع:", err);
    }
  };

  useEffect(() => {
    fetchTopics();
  }, []);

  const handlePageChange = (newPage) => {
    fetchTopics(newPage);
  };

  const formattedTopics = topics.map((item, index) => ({
    ...item,
    index: (pagination.page - 1) * 10 + index + 1,
  }));

  const columns = [
    { label: "#", field: "index" },
    { label: "الموضوع", field: "topic_name" },
    ...yearsTopics.map((year) => ({
      label: year,
      field: year,
      render: (row) => {
        const achievement = row.achievement_by_year[year];
        const percentage = achievement?.percentage ?? 0;
        const classification = achievement?.classification ?? "Weak";

        const badgeColor = {
          Excellent: "success",
          Good: "info",
          Acceptable: "secondary",
          Weak: "danger",
        }[classification] || "secondary";

        return (
          <div>
            <ProgressBar
              now={percentage}
              variant="primary"
              style={{ height: "6px" }}
            />
            <div className="d-flex align-items-center justify-content-center mt-1">
              <Badge variant="primary light" className="ml-2">
                {percentage.toFixed(2)}%
              </Badge>
              <span className={`badge badge-${badgeColor} ml-2`}>
                {classification}
              </span>
            </div>
          </div>
        );
      },
    })),
  ];

  return (
    <BasisTableComponent
      data={formattedTopics}
      columns={columns}
      pagination={pagination}
      onPageChange={handlePageChange}
      title="مقارنة نسبة تحقيق المواضيع في المقرر وتصنيفها اخر 5 سنوات"
    />
  );
};

export default TopicsComparisonTable;
